import React from 'react'
import { InflatedListItemProduct } from '../list/ListTypes'
import { ClipspecWorkflow } from './clipspec-api/ClipspecIntegrationAPI'

export interface ClipspecContextShape {
  onHandoffList: (products: readonly InflatedListItemProduct[]) => Promise<void>
  workflow: ClipspecWorkflow
  clearListRequested: boolean
}

export const ClipspecContext = React.createContext<ClipspecContextShape | null>(null)